export function isCookieSet(cookieName) {
    return document.cookie.includes(cookieName);
}
export function deleteCookie(cookieName) {
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
}
export function setCookie(cookieName, cookieValue, expireInSeconds = "") {
    let localExpires = expireInSeconds

    if (typeof expireInSeconds === 'number') {
        const now = new Date();
        const time = now.getTime()
        const expireTime = time + expireInSeconds * 1000;
        localExpires = new Date(expireTime)
    }

    document.cookie = `${cookieName}=${cookieValue}; expires=${localExpires}; path=/`;
}
export function getCookieValue(cookieName) {
    const cookies = document.cookie.split(';').map(cookie => cookie.trim());
    for (const cookie of cookies) {
        const [name, value] = cookie.split('=');
        if (name === cookieName) {
            return value;
        }
    }
    return null;
}
